import React, { useState } from "react";
import CapitaliseWords from "../../../../shared/utils/CapitaliseWords";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Select,
  MenuItem,
  Button,
  IconButton,
  FormHelperText,
  FormControl,
} from "@mui/material";
import CustomInput from "../../../../shared/utils/Input";
import CloseIcon from "@mui/icons-material/Close";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import axios from "axios";
import { CircularProgress } from "@mui/material";
import GlobalButton from "../../../../shared/utils/GlobalButton";

const PaymentDialog = ({ open, onClose, selectedRow, userListData }) => {
  const selectPaymentMethod = [
    { name: "RTGS" },
    { name: "NEFT" },
    { name: "IMPS" },
    { name: "UPI" },
    { name: "CASH" },
  ];
  const serverURL = process.env.REACT_APP_URL;
  const [data, setData] = useState({
    budget: selectedRow?.paymentStats?.totalPaymentAmount || "",
    tillnow: selectedRow?.paymentStats?.vendorAmountPaid || 0,
    balance: selectedRow?.paymentStats?.pendingPayment || "",
    paidnow: selectedRow?.paymentStats?.amountPaid || "",
    utr: selectedRow?.paymentStats?.transactionId || "",
    date: null,
    paymentMethod: selectedRow?.paymentStats?.paymentMethod || "",
  });
  const [isbudget, setIsamount] = useState(true);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const validateForm = () => {
    let newErrors = {};
    if (!data.utr.trim()) newErrors.utr = "UTR is required";

    if (!data.date) newErrors.date = "Date is required";
    if (!data.paymentMethod)
      newErrors.paymentMethod = "Payment Method is required";
    if (!data?.paidnow || Number(data?.paidnow) <= 0) {
      newErrors.paidnow = "Please enter a valid payment amount";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    setIsLoading(true);

    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${serverURL}/vendorPayment/createPayment`,
        {
          paymentAmount: data.budget,
          tillnow: data.tillnow,
          balance: data.balance,
          amountPaid: data.paidnow,
          transactionId: data.utr,
          paymentDate: data.date,
          paymentMethod: data.paymentMethod,
          vendorId: selectedRow?.vendorId?._id,
          clusterId: selectedRow?.clusterId?._id,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (response?.data?.success) {
        handleCloseDialog();
        userListData();
      } else {
        console.error("Update Failed:", response[0].data);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleCloseDialog = () => {
    setData({
      budget: "",
      tillnow: "",
      balance: "",
      paidnow: "",
      utr: "",
      date: "",
      paymentMethod: "",
    });
    setIsamount(true);
    onClose(); // Call the parent component's onClose function
  };

  const handleEdit = () => {
    setIsamount(false);
  };

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          handleCloseDialog(); // Ensure data resets when closing
        }
      }}
      maxWidth="md"
      fullWidth
      BackdropProps={{
        sx: { backdropFilter: "blur(8px)" }, // Fix: Use `sx` instead of `style`
      }}
    >
      <DialogTitle className="flex justify-between items-center border-b p-4 font-semibold text-xl">
        VP Payment Update
        <IconButton onClick={handleCloseDialog} className="text-gray-500 ">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className="p-6 md:space-y-4">
        <div className="flex flex-col md:flex-row md:m-2">
          <div className=" p-4 rounded-lg bg-gray-50 md:w-1/2 ">
            <div className="flex items-center space-x-4">
              <div>
                <h2 className="md:text-3xl font-semibold">
                  {selectedRow?.vendorId?.vendorBusinessName ?? "N/A"}
                </h2>
                <p className="md:text-lg text-gray-500">
                  {selectedRow?.vendorId?.ownerName ?? "N/A"}
                </p>
                <p className="md:text-sm text-gray-500">
                  {selectedRow?.vendorId?.address ?? "N/A"}
                </p>
                <p className="md:text-sm text-gray-500">
                  {selectedRow?.vendorId?.ownerPrimaryContactNo ?? "N/A"}
                </p>
              </div>
            </div>
            <hr className="my-4" />
            <div className="">
              <h3 className="font-semibold">Campaign Name </h3>
              <p className="text-sm mb-4">
                {" "}
                {CapitaliseWords(selectedRow?.campaignId?.campaignTitle)}
              </p>
              <h3 className="font-semibold">Job Timeline</h3>
              <p className="text-sm mb-4">
                {selectedRow?.clusterId?.jobStartingDate
                  ? new Date(
                      selectedRow.clusterId.jobStartingDate,
                    ).toLocaleDateString("en-GB")
                  : "N/A"}
                -
                {selectedRow?.clusterId?.jobCompletionDate
                  ? new Date(
                      selectedRow.clusterId.jobCompletionDate,
                    ).toLocaleDateString("en-GB")
                  : "N/A"}
              </p>
              <h3 className="font-semibold">Service</h3>
              <p className="text-sm mb-4">
                {selectedRow?.clusterId?.serviceType === "0"
                  ? "Printing, Fabrication"
                  : selectedRow?.clusterId?.serviceType === "2"
                    ? "Fabrication"
                    : selectedRow?.clusterId?.serviceType === "1"
                      ? "Printing"
                      : "Unknown Service"}
              </p>
              <h3 className="font-semibold">Payments</h3>
              {selectedRow?.payments && selectedRow?.payments?.length > 0 ? (
                selectedRow?.payments.map((payment, index) => (
                  <div key={index} className="flex items-center space-x-2 mb-2">
                    <p className="text-sm">
                      {payment?.paymentDate
                        ? new Date(payment?.paymentDate).toLocaleDateString(
                            "en-GB",
                          )
                        : "N/A"}
                      - {payment?.amountPaid}
                    </p>
                  </div>
                ))
              ) : (
                <p className="text-sm text-gray-500">No payments yet !</p>
              )}
            </div>
          </div>
          <div className="mx-6 md:w-1/2">
            <div className="mb-10">
              <div className="flex justify-between items-center">
                <h3
                  style={{
                    color: errors?.budget
                      ? "var(--error-color)"
                      : "var(--heading-color)",
                    fontFamily: "Helvetica",
                    fontWeight: "bold",
                    fontSize: "1rem",
                    marginBottom: "8px",
                  }}
                >
                  Total Cluster Budget
                </h3>
                <p
                  className={`inline-flex items-center gap-1 cursor-pointer m-0 p-0 ${
                    isbudget
                      ? "text-[var(--primary-color)]"
                      : "text-[var(--para-color)]"
                  }`}
                  onClick={isbudget ? handleEdit : undefined}
                >
                  <BorderColorOutlinedIcon fontSize="small" />
                  <span>Edit</span>
                </p>
              </div>
              <CustomInput
                name="budget"
                disabled={isbudget}
                placeholder="Enter Cluster Budget"
                value={data.budget}
                size="small"
                type="number"
                error={!!errors?.budget}
                required
                onChange={(e) => {
                  handleInputChange(e);
                }}
                onFocus={(e) => {
                  e.target.addEventListener(
                    "wheel",
                    (event) => {
                      event.preventDefault();
                    },
                    { passive: false },
                  );
                }}
                onBlur={(e) => {
                  e.target.removeEventListener("wheel", (event) => {
                    event.preventDefault();
                  });
                }}
              />
              {errors?.budget && (
                <FormHelperText
                  sx={{
                    color: "var(--error-color)",
                    marginTop: 1,
                    marginLeft: 1.5,
                  }}
                >
                  {errors?.budget}
                </FormHelperText>
              )}
            </div>
            <div className="mb-10">
              <h3
                style={{
                  color: errors?.tillnow
                    ? "var(--error-color)"
                    : "var(--heading-color)",
                  fontFamily: "Helvetica",
                  fontWeight: "bold",
                  fontSize: "1rem",
                  marginBottom: "8px",
                }}
              >
                Paid till now
              </h3>
              <CustomInput
                name="tillnow"
                disabled={isbudget}
                placeholder="Enter Paid Amount"
                value={data.tillnow}
                size="small"
                type="number"
                error={!!errors?.tillnow}
                required
                onChange={(e) => {
                  handleInputChange(e);
                }}
                onFocus={(e) => {
                  e.target.addEventListener(
                    "wheel",
                    (event) => {
                      event.preventDefault();
                    },
                    { passive: false },
                  );
                }}
                onBlur={(e) => {
                  e.target.removeEventListener("wheel", (event) => {
                    event.preventDefault();
                  });
                }}
              />
              {errors?.tillnow && (
                <FormHelperText
                  sx={{
                    color: "var(--error-color)",
                    marginTop: 1,
                    marginLeft: 1.5,
                  }}
                >
                  {errors?.tillnow}
                </FormHelperText>
              )}
            </div>
            <div className="mb-10">
              <h3
                style={{
                  color: errors?.balance
                    ? "var(--error-color)"
                    : "var(--heading-color)",
                  fontFamily: "Helvetica",
                  fontWeight: "bold",
                  fontSize: "1rem",
                  marginBottom: "8px",
                }}
              >
                Balance Amount
              </h3>
              <CustomInput
                name="balance"
                disabled={!isbudget}
                placeholder="Enter Balance Amount"
                value={data.balance}
                size="small"
                type="number"
                error={!!errors?.balance}
                required
                onChange={(e) => {
                  handleInputChange(e);
                }}
                onFocus={(e) => {
                  e.target.addEventListener(
                    "wheel",
                    (event) => {
                      event.preventDefault();
                    },
                    { passive: false },
                  );
                }}
                onBlur={(e) => {
                  e.target.removeEventListener("wheel", (event) => {
                    event.preventDefault();
                  });
                }}
              />
              {errors?.balance && (
                <FormHelperText
                  sx={{
                    color: "var(--error-color)",
                    marginTop: 1,
                    marginLeft: 1.5,
                  }}
                >
                  {errors?.balance}
                </FormHelperText>
              )}
            </div>
            <div className="mb-10">
              <h3
                style={{
                  color: errors?.paidnow
                    ? "var(--error-color)"
                    : "var(--heading-color)",
                  fontFamily: "Helvetica",
                  fontWeight: "bold",
                  fontSize: "1rem",
                  marginBottom: "8px",
                }}
              >
                Pay Now *
              </h3>
              <CustomInput
                name="paidnow"
                disabled={!isbudget}
                placeholder="Enter Amount"
                value={data.paidnow}
                size="small"
                type="number"
                error={errors?.paidnow}
                required
                inputProps={{
                  "aria-required": "true",
                  min: "0.01",
                  step: "any",
                  "aria-label": "Payment amount required",
                }}
                onChange={(e) => {
                  // Clear error when user starts typing
                  if (errors?.paidnow) {
                    setErrors({ ...errors, paidnow: undefined });
                  }
                  handleInputChange(e);
                }}
                onFocus={(e) => {
                  e.target.addEventListener(
                    "wheel",
                    (event) => {
                      event.preventDefault();
                    },
                    { passive: false },
                  );
                }}
                onBlur={(e) => {
                  // Validate on blur
                  if (!e.target.value || Number(e.target.value) <= 0) {
                    setErrors({
                      ...errors,
                      paidnow: "Please enter a valid payment amount",
                    });
                  }
                  e.target.removeEventListener("wheel", (event) => {
                    event.preventDefault();
                  });
                }}
              />
              {errors?.paidnow && (
                <FormHelperText
                  sx={{
                    color: "var(--error-color)",
                    marginTop: 1,
                    marginLeft: 1.5,
                  }}
                >
                  {errors?.paidnow}
                </FormHelperText>
              )}
            </div>
            {/* utr */}
            <div className="mb-10">
              <h3
                style={{
                  color: errors?.utr
                    ? "var(--error-color)"
                    : "var(--heading-color)",
                  fontFamily: "Helvetica",
                  fontWeight: "bold",
                  fontSize: "1rem",
                  marginBottom: "8px",
                }}
              >
                UTR *
              </h3>
              <CustomInput
                name="utr"
                disabled={!isbudget}
                placeholder="Enter UTR"
                value={data.utr}
                size="small"
                error={!!errors?.utr}
                required
                onChange={(e) => {
                  handleInputChange(e);
                }}
                onFocus={(e) => {
                  e.target.addEventListener(
                    "wheel",
                    (event) => {
                      event.preventDefault();
                    },
                    { passive: false },
                  );
                }}
                onBlur={(e) => {
                  e.target.removeEventListener("wheel", (event) => {
                    event.preventDefault();
                  });
                }}
              />
              {errors?.utr && (
                <FormHelperText
                  sx={{
                    color: "var(--error-color)",
                    marginTop: 1,
                    marginLeft: 1.5,
                  }}
                >
                  {errors?.utr}
                </FormHelperText>
              )}
            </div>
            <div className="mb-10">
              <h3
                style={{
                  color: errors?.date
                    ? "var(--error-color)"
                    : "var(--heading-color)",
                  fontFamily: "Helvetica",
                  fontWeight: "bold",
                  fontSize: "1rem",
                  marginBottom: "8px",
                }}
              >
                Payment Date *
              </h3>
              <CustomInput
                name="date"
                placeholder="Enter date"
                disabled={!isbudget}
                value={data.date}
                size="small"
                type="date"
                error={!!errors?.date}
                required
                onChange={(e) => {
                  handleInputChange(e);
                }}
              />
              {errors?.date && (
                <FormHelperText
                  sx={{
                    color: "var(--error-color)",
                    marginTop: 1,
                    marginLeft: 1.5,
                  }}
                >
                  {errors?.date}
                </FormHelperText>
              )}
            </div>
            <div className="mb-10">
              <h3
                style={{
                  color: errors?.paymentMethod
                    ? "var(--error-color)"
                    : "var(--heading-color)",
                  fontFamily: "Helvetica",
                  fontWeight: "bold",
                  fontSize: "1rem",
                }}
              >
                Payment Method *
              </h3>
              <FormControl
                label="State *"
                fullWidth
                disabled={!isbudget}
                size="small"
                sx={{ marginTop: "0.5rem" }}
                error={errors?.paymentMethod}
                errorMessage={
                  errors?.paymentMethod ? (
                    <span style={{ color: "var(--error-color)" }}>
                      Please Enter Payment Method
                    </span>
                  ) : null
                }
                value={data?.paymentMethod}
              >
                <Select
                  inputProps={{
                    "aria-label": "Without label",
                  }}
                  displayEmpty
                  name="paymentMethod"
                  value={data.paymentMethod}
                  onChange={handleInputChange}
                  renderValue={(selected) => {
                    if (!selected) {
                      return (
                        <p className="text-[1rem] ">Enter Payment Method</p>
                      );
                    }

                    return selected;
                  }}
                >
                  {selectPaymentMethod.map((state) => (
                    <MenuItem key={state.name} value={state.name}>
                      {state.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {errors?.paymentMethod && (
                <p className="font-normal text-[0.75rem] leading-[1.66] tracking-[0.03em] text-left mt-[6px] mr-[14px] mb-0 ml-[14px] text-[var(--error-color)]">
                  {errors?.paymentMethod}
                </p>
              )}
            </div>
            <div
              className={isbudget ? "text-end" : "flex justify-between gap-4"}
            >
              {!isbudget ? (
                <>
                  <GlobalButton
                    variant="secondary"
                    size="medium"
                    onClick={() => {
                      setIsamount(true);
                      setData({
                        amount: "",
                        utr: "",
                        date: "",
                        paymentMethod: "",
                      });
                    }}
                  >
                    {`Discard Changes`}
                  </GlobalButton>
                  <GlobalButton
                    variant="primary"
                    size="medium"
                    isLoading={isLoading}
                    onClick={() => setIsamount(true)}
                  >
                    {`Save Payment`}
                  </GlobalButton>
                </>
              ) : (
                <GlobalButton
                  variant="primary"
                  size="medium"
                  isLoading={isLoading}
                  onClick={async () => {
                    await handleSubmit();
                  }}
                >
                  {`Submit Payment`}
                </GlobalButton>
              )}
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentDialog;
